<template>
  <b-modal
    :id="modalId"
    :title="$t('message.areyousuretodeletethis')"
    hideFooter
    noCloseOnBackdrop
    noCloseOnEsc
    hideHeaderClose
    noFade
  >
    <div
      class="d-flex justify-content-end"
      style="gap: 10px;">
      <template v-if="!loading">
        <button
          type="button"
          class="btn btn-light"
          @click="onCancel">{{ $t('button.cancel') }}</button>
        <button
          type="button"
          class="btn btn-danger"
          @click="onSubmit">{{ $t('button.delete') }}</button>
      </template>
      <template v-else>
        <button
          type="button"
          class="btn btn-light"
          disabled>{{ $t('button.cancel') }}</button>
        <button
          type="button"
          class="btn btn-danger"
          disabled>
          <i class="fas fa-spinner spin"/>
        </button>
      </template>
    </div>
  </b-modal>
</template>

<script>
import { uuid } from 'vue-uuid'

export default {
  props: ['show', 'loading', 'description'],

  data() {
    return {
      id: uuid.v1(),
    }
  },

  computed: {
    modalId() {
      return `${this.id}-confirmdeleteModal`
    },
  },

  watch: {
    show () {
      if (this.show) {
        this.$bvModal.show(this.modalId)
      } else {
        this.$bvModal.hide(this.modalId)
      }
    },
  },

  mounted () {
    if (this.show) {
      this.$bvModal.show(this.modalId)
    }
  },

  destroyed () {
    this.leavePage(this.$Progress)
  },

  methods: {
    onClose () {
      this.$emit('onClose')
    },
    onCancel () {
      this.$emit('onCancel')
    },
    onSubmit () {
      this.$emit('onSubmit')
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/base/BaseConfirmDeleteModal.vue